var map = {
	"./bitcoin.png": "8bdd",
	"./china.png": "c6ac",
	"./japan.png": "b1d7",
	"./ngn.png": "a6fd",
	"./nigeria.png": "37e5",
	"./united-states.png": "6d8e",
	"./usa.png": "21d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "50c1";